import React, { useState, useEffect } from "react";

const CustomSlider = ({ slides, interval = 4000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const autoPlay = setInterval(nextSlide, interval);

    return () => clearInterval(autoPlay);
  }, [currentIndex, interval]); 

  return (
    <div
      className="slider-container CustomSlider-Host"
      onMouseEnter={() => clearInterval()} 
      onMouseLeave={() => setCurrentIndex((prev) => prev)}
    >
      <div className="slider">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <img src={slide} alt={`Slide ${index + 1}`} className="slide-image" />
            </div>
          ))}
        </div>
      </div>

      <button onClick={prevSlide} className="slider-button prev">&#10094;</button>
      <button onClick={nextSlide} className="slider-button next">&#10095;</button>
    </div>
  );
};

export default CustomSlider;
